import React from "react";

// Polished initials avatar used when a real photo is not yet available.
// `accent` => 'navy' (default) or 'gold'
const InitialsAvatar = ({
  initials = "TB",
  accent = "navy",
  className = "h-full w-full",
}) => {
  const isGold = accent === "gold";
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      aria-hidden="true"
      style={{
        background: isGold
          ? "linear-gradient(135deg, #F3E7C2 0%, #D4A24C 55%, #9A7521 100%)"
          : "linear-gradient(135deg, #14284A 0%, #0E1A2F 60%, #060B17 100%)",
      }}
    >
      {/* Subtle dotted texture */}
      <div
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "18px 18px",
        }}
      />
      {/* Decorative ring */}
      <div className="absolute -right-10 -top-10 h-44 w-44 rounded-full bg-[hsl(var(--accent))]/15 blur-xl" />
      <div className="absolute inset-0 grid place-items-center">
        <span
          className={`font-display tracking-tight select-none ${
            isGold ? "text-[#0E1A2F]" : "text-white"
          }`}
          style={{ fontSize: "clamp(2.25rem, 6vw, 5rem)" }}
        >
          {initials}
        </span>
      </div>
      {/* Bottom gold rule */}
      <div
        className="absolute left-6 right-6 bottom-5 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(212,162,76,0.85) 50%, transparent 100%)",
        }}
      />
    </div>
  );
};

export default InitialsAvatar;
